export const APP_ROUTES_PATHS = {
  EMPLOYEE: 'employee',
  REGISTRATION: 'registration',
} as const;
